import { secureStorage } from "../utils/secureStorage";

const BASE_URL = "https://scholarbackend.seasensegroup.com/api/sclr";
//const BASE_URL = "http://scholarapi.seasense.in/api/sclr";

// Get Payments
export const getPayments = async (scholarId) => {
  const token = secureStorage.getToken();

  const response = await fetch(
    `${BASE_URL}/payments/${scholarId}`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        ...(token && {
          Authorization: `Bearer ${token}`,
        }),
      },
    }
  );

  if (!response.ok) {
    throw new Error(
      `HTTP error! status: ${response.status}`
    );
  }

  return await response.json();
};